import { SursaSnapshotPanel } from "../components/SursaSnapshotPanel";

export default function ContribuabiliAnaf() {
  return (
    <SursaSnapshotPanel
      sursa="anaf"
      descriere={
        <>
          Registrul ANAF de contribuabili: telefon, fax, statutul TVA și starea
          fiscală, pe CUI-urile existente. Firmele absente din noul export
          primesc starea „absent”, nu li se șterge telefonul anterior. O scădere
          de peste 2 % a numărului de telefoane distincte oprește aplicarea fără
          „forțează”.
        </>
      }
      comandaScript={
        'python -m scripts.actualizare.actualizare anaf --proiect dev --sursa "../FIRME SEPT 26"'
      }
    />
  );
}
